import React, { PropTypes } from 'react';
import { Field } from 'redux-form';
import { TextInputField } from 'common/components/form_fields';

const SocialInput = ({ name }) => (
  <div className="social-input">
    <i className={`fa fa-${name}`} />
    <Field name={name} component={TextInputField} />
  </div>
);

const EditSocial = () => (
  <div className="profile-social">
    <h4>Connect</h4>
    <p>Add only your username for each network.</p>
    <SocialInput name="twitter" />
    <SocialInput name="behance" />
    <SocialInput name="dribbble" />
    <SocialInput name="facebook" />
    <SocialInput name="linkedin" />
  </div>
);

SocialInput.propTypes = {
  name: PropTypes.string.isRequired,
};

export { SocialInput };
export default EditSocial;



// WEBPACK FOOTER //
// ./profile/components/edit_social.jsx